import React from 'react';

import { Col, Row } from 'react-bootstrap';

import {
    CheckboxField,
    ControlPageBlock,
    DateTimeField,
    ImageLeadField,
    InputField,
    SearchSelectorField,
    TextAreaEditorField,
} from '../blocks/edit_blocks';
import Fetcher from '../common/communicate';
import { API_DOMAIN, PROJECT_PREFIX } from '../const';
import clearCache from '../tools/clearCache';
import { formatDateTimeForDRF, getMoscowTime, Text2Slug } from '../tools/converters';

export default class CommercialEditScreen extends React.Component {
    constructor(props) {
        super(props);

        const current_date = new Date(getMoscowTime()).toISOString();
        this.state = {
            timer: null,
            data: {
                descr: '',
                date_published: formatDateTimeForDRF(current_date),

            },
            not_valid: {},
            loading: true,
        };
        this.baseState = this.state;
        this.autoSave = this.autoSave.bind(this);
        this.onChange = (editorState) => this.setState({ editorState });
        this.handleChange = this.handleChange.bind(this);
        this.titleChange = this.titleChange.bind(this);
        this.handleData = this.handleData.bind(this);
        this.dtHandleChange = this.dtHandleChange.bind(this);
        this.sendData = this.sendData.bind(this);
        this.removeData = this.removeData.bind(this);
        this.goToNewPage = this.goToNewPage.bind(this);
        this.goToPreviousPage = this.goToPreviousPage.bind(this);
        this.forceUpdate = this.forceUpdate.bind(this);
        this.searchAuthorChange = this.searchAuthorChange.bind(this);
        this.parseData = this.parseData.bind(this);
        this.generateData = this.generateData.bind(this);

        const { project, storyId } = props.match.params;

        if (storyId) {
            this.state.API_ENDPOINT = `v2/${project}/story/commercial/${storyId}/`;
        } else {
            this.state.API_ENDPOINT = `v2/${project}/story/commercial/`;
        }
    }

    parseData(data) {
        const { slug, picture, is_published } = data;

        const {
            title, author, description, published_at, url, id,
        } = data.content[0];

        return {
            name: title,
            slug,
            url,
            is_published,
            date_published: published_at,
            descr: description,
            author_info: {
                email: 'автор',
                nick: author.name,
            },
            picture,
            picture_2x: '',
            content_id: id,
        };
    }

    generateData() {
        const { project } = this.props.match.params;

        const {
            author_info, author_email, name, descr, url, picture, slug, is_published, content_id,
        } = this.state.data;

        return {
            content: [{
                id: content_id,
                author: {
                    name: author_info.nick,
                },
                author_info: {
                    nick: author_info.nick,
                    email: author_info.email,
                },
                author_email,
                title: name,
                description: descr,
                url,
                custom_canonical: url,
            }],
            picture,
            picture_square: picture,
            picture_vertical: picture,
            project_name: project,
            slug,
            is_published,
            media: [],
            channels: [],
            games: [],
            rating: 0,
            type: 'commercial',
            in_progress: false,
            disable_comments: true,
        };
    }

    handleData(data) {
        this.setState({ loading: false, data: this.parseData(data) });
    }

    autoSave() {
        this.sendData({ target: { id: 'autosave' }, currentTarget: { id: 'autosave' } });
    }

    componentWillUnmount() {
        clearInterval(this.state.timer);
    }

    sendData(event) {
        const { project, storyId } = this.props.match.params;

        this.validate();
        const save_type = event.currentTarget.id;

        const callback = (data) => {
            const { url } = this.state.data;

            clearCache(url);

            if (save_type === 'save_button') {
                return this.goToPreviousPage(data);
            }

            if (!storyId) {
                return this.goToNewPage(data);
            }

            this.handleData(data);
        };

        const request_method = storyId ? 'PATCH' : 'POST';
        const url = storyId ? `v2/${project}/story/commercial/${storyId}/` : `v2/${project}/story/commercial/`;

        Fetcher(url, request_method, callback, this.generateData());
    }

    goToNewPage({ id }) {
        const { project } = this.props.match.params;

        this.setState({ API_ENDPOINT: `v2/${project}/story/commercial/${id}/` });
        this.props.history.push(`${PROJECT_PREFIX}/${project}/story/commercial/${id}/edit`);
    }

    goToPreviousPage() {
        const { project } = this.props.match.params;

        this.props.history.push(`${PROJECT_PREFIX}/${project}/story/commercial/all`);
    }

    removeData() {
        Fetcher(this.state.API_ENDPOINT, 'DELETE', this.goToPreviousPage);
    }

    forceUpdate() {
        this.setState({ ...this.baseState });

        Fetcher(this.state.API_ENDPOINT, 'GET', this.handleData);
    }

    componentDidMount() {
        const current_date = new Date(getMoscowTime()).toISOString();

        const { storyId } = this.props.match.params;

        if (storyId) {
            const timer = setInterval(this.autoSave, 300000);

            this.setState({ timer });

            Fetcher(this.state.API_ENDPOINT, 'GET', this.handleData);
        } else {
            this.setState({
                loading: false,
                data: {
                    name: '',
                    slug: '',
                    url: '',
                    is_published: false,
                    date_published: formatDateTimeForDRF(current_date),
                    descr: '',
                    author_email: 'games.gamemailru@mail.ru',
                    author_info: { email: 'games.gamemailru@mail.ru', nick: 'Игры@Mail.Ru' },
                    picture: '',
                    picture_2x: '',
                },
            });
        }
    }

    getBase64(file, cb) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            cb(reader.result);
        };

        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    dtHandleChange(date) {
        const new_state = this.state;
        new_state.data.date_published = date;
        this.setState(new_state);
    }

    handleChange(event) {
        let state = event.currentTarget.value;

        // Обновление значений URL
        if (event.currentTarget.type === 'author_email') {
            state = event.currentTarget.value.value;
        }

        if (event.currentTarget.type === 'checkbox') {
            state = event.currentTarget.checked;
        }

        if (event.currentTarget.type === 'file') {
            const file = event.currentTarget.files[0];
            // let file_size = file.size/1024/1024;
            const file_type = file.type;

            if (file_type !== 'image/jpeg' && file_type !== 'image/png') {
                return;
                // TODO: окно с сообщением, что формат файла не подходит
            }

            const event_target_id = event.currentTarget.id;
            this.getBase64(file, (result) => {
                const new_state = this.state;
                new_state.data[event_target_id] = result;
                this.setState(new_state);
            });

            return;
        }

        const new_state = this.state;
        new_state.data[event.currentTarget.id] = state;
        this.setState(new_state);
    }

    searchAuthorChange(event) {
        const newState = this.state.data;
        newState.author_info = {
            email: event.currentTarget.value.value,
            nick: event.currentTarget.value.label,
        };

        newState.author_email = event.currentTarget.value.value;
        this.setState(newState);
    }

    titleChange(event) {
        const { storyId } = this.props.match.params;

        const state = event.currentTarget.value;
        const new_state = this.state;
        new_state.data[event.currentTarget.id] = state;

        if (!storyId) {
            new_state.data.slug = `special-${Text2Slug(state)}-${Date.now()}`;
        }

        this.setState(new_state);
    }

    validate() {
        const no_valid_fields = {};
        const req_fields = ['name', 'picture', 'picture_2x', 'author_info', 'url'];

        for (let i = 0; i < Object.keys(req_fields).length; i++) {
            if (!this.state.data[req_fields[i]]) {
                no_valid_fields[req_fields[i]] = true;
            }
        }

        this.setState({ not_valid: Object.assign(this.state.not_valid, no_valid_fields) });
    }

    render() {
        if (this.state.loading) {
            return null;
        }

        return (
            <div>
                <Row className="show-grid">
                    <Col md={12}>
                        <h3>
                            Коммерческий материал:
                            {this.state.data.name}
                        </h3>
                    </Col>
                </Row>

                <Row className="show-grid">
                    <Col md={6}>
                        <InputField
                            name="name"
                            label="Имя"
                            value={this.state.data.name}
                            onChange={this.titleChange}
                            maxLength={100}
                            required
                            is_not_valid={this.state.not_valid.name || false}
                        />
                    </Col>
                    <Col md={6}>
                        <InputField
                            name="url"
                            label="Ссылка"
                            value={this.state.data.url}
                            onChange={this.handleChange}
                            maxLength={255}
                            required
                            is_not_valid={this.state.not_valid.name || false}
                        />
                    </Col>
                </Row>

                <Row className="show-grid">
                    <Col md={6}>
                        <InputField
                            name="slug"
                            label="Slug"
                            value={this.state.data.slug}
                            onChange={this.handleChange}
                            maxLength={150}
                            required
                            is_not_valid={this.state.not_valid.slug || false}
                            readOnly
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <TextAreaEditorField
                            name="descr"
                            label="Краткое описание"
                            value={this.state.data.descr}
                            onChange={this.handleChange}
                            maxLength={200}
                            rows={4}
                        />
                    </Col>
                    <Col md={2}>
                        <ImageLeadField
                            name="picture"
                            label="Картинка"
                            value={this.state.data.picture}
                            restrictions="Разрешение не менее 340x200. Формат: jpeg."
                            minSize="340x200"
                            onChange={this.handleChange}
                            required
                            is_not_valid={this.state.not_valid.picture || false}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={3}>
                        <SearchSelectorField
                            name="author_info"
                            label="Автор редакции"
                            value={[this.state.data.author_info]}
                            isAuthors
                            uri={`${API_DOMAIN}authors/`}
                            onChange={this.searchAuthorChange}
                            isMulti={false}
                            required
                            is_not_valid={this.state.not_valid.author_info || false}
                        />
                    </Col>
                    <Col md={2}>
                        <DateTimeField
                            name="date_published"
                            label="Дата публикации (по Москве)"
                            value={this.state.data.date_published || formatDateTimeForDRF(new Date(getMoscowTime()))}
                            onChange={this.dtHandleChange}
                        />
                    </Col>
                </Row>

                <Row>
                    <Col md={2}>
                        <CheckboxField
                            name="is_published"
                            label="Опубликовано"
                            value={this.state.data.is_published}
                            onChange={this.handleChange}
                        />
                    </Col>
                </Row>

                <ControlPageBlock
                    isClearableCache
                    url={this.state.data.url}
                    name={this.state.data.name}
                    onSave={this.sendData}
                    onApply={this.sendData}
                    onCancel={this.goToPreviousPage}
                    onRemove={this.removeData}
                />
            </div>

        );
    }
}
